{
  "„{name}“ hat nur die Admin-Rolle und wird vollständig gelöscht. Das kann nicht rückgängig gemacht werden.": "“{name}” only has the admin role and will be deleted completely. This cannot be undone.",
  "„{name}“ hat nur die Client-Rolle und wird vollständig gelöscht. Dabei werden auch {accommodations} samt aller zugehörigen Daten unwiderruflich gelöscht und können nicht wiederhergestellt werden.": "“{name}” only has the client role and will be deleted completely. This also permanently deletes {accommodations} and all their data, which cannot be recovered.",
  "„{name}“ hat weitere Rollen. Es wird nur die Admin-Rolle entfernt; das Konto bleibt bestehen.": "“{name}” has other roles. Only the admin role is removed; the account remains.",
  "„{name}“ hat weitere Rollen. Es wird nur die Client-Rolle entfernt; das Konto und die {accommodations} bleiben bestehen.": "“{name}” has other roles. Only the client role is removed; the account and its {accommodations} remain.",
  "„{name}“ ist jetzt für Gäste sichtbar.": "“{name}” is now visible to guests.",
  "„{name}“ wurde gespeichert.": "“{name}” was saved.",
  "„{name}“ wurde zurückgezogen.": "“{name}” was unpublished.",
  "„{title}“ wurde gespeichert und gegen den Import gesperrt.": "“{title}” was saved and locked against the import.",
  "(abgesagt)": "(cancelled)",
  "(Gastgeber-Zugang)": "(host access)",
  "(gekürzt — die nächstgelegenen zuerst)": "(truncated — nearest first)",
  "(jeder {step}. gezeichnet)": "(every {step}th point drawn)",
  "(Plattform-Zugang)": "(platform access)",
  "{content} regionale Inhalte aus {sources} Datenquellen stehen allen Gästemappen zur Verfügung.": "{content} regional entries from {sources} data sources are available to every guest directory.",
  "{count} Anfragen": {
    "one": "{n} request",
    "other": "{n} requests"
  },
  "{count} Anfragen ohne hinterlegten Preis": {
    "one": "{n} request without a configured price — not included in the total",
    "other": "{n} requests without a configured price — not included in the total"
  },
  "{count} Einträge innerhalb von {radius} entlang der Strecke": {
    "one": "{count} entry within {radius} of the route",
    "other": "{count} entries within {radius} of the route"
  },
  "{count} Garten": "{count} garden",
  "{count} innen": "{count} indoor",
  "{count} Kategorien": {
    "one": "{count} category",
    "other": "{count} categories"
  },
  "{count} markiert": "{count} marked",
  "{count} Quellen fehlgeschlagen": {
    "one": "{n} source failed",
    "other": "{n} sources failed"
  },
  "{count} Streckenpunkte": "{count} track points",
  "{count} Terrasse": "{count} terrace",
  "{count} Unterkünfte": {
    "one": "{count} accommodation",
    "other": "{count} accommodations"
  },
  "{count} Unterkünfte live.": {
    "one": "{n} accommodation live.",
    "other": "{n} accommodations live."
  },
  "{distance} von der Strecke": "{distance} from the route",
  "{months} Monate": "{months} months",
  "{n} aktiv": "{n} active",
  "{n} aktualisiert": "{n} updated",
  "{n} archiviert": "{n} archived",
  "{n} außerhalb des Umkreises": "{n} outside the radius",
  "{n} Bilder kopiert": "{n} images copied",
  "{n} Bilder offen": "{n} images pending",
  "{n} Bilder ohne passende Lizenz": "{n} images without a suitable licence",
  "{n} Dubletten erkannt": "{n} duplicates detected",
  "{n} Dubletten freigegeben": "{n} duplicates released",
  "{n} Entwurf": "{n} draft",
  "{n} fehlerhaft": "{n} failed",
  "{n} gesperrt": "{n} locked",
  "{n} neu": "{n} new",
  "{n} unverändert": "{n} unchanged",
  "{n} veröffentlicht": "{n} published",
  "{time} Uhr": "{time}",
  "+ {count} weitere": "+ {count} more",
  "Ab heute in die Zukunft.": "From today into the future.",
  "Abbrechen": "Cancel",
  "Abgesagt": "Cancelled",
  "Abmelden": "Sign out",
  "Abonnements": "Subscriptions",
  "Abstieg": "Descent",
  "Admin": "Admin",
  "Admin bearbeiten": "Edit admin",
  "Admin-Benutzer „{name}“ wurde aktualisiert.": "Admin user “{name}” was updated.",
  "Admin-Benutzer „{name}“ wurde angelegt.": "Admin user “{name}” was created.",
  "Admin-Rolle entfernen?": "Remove admin role?",
  "Admin-Rolle wurde entfernt.": "Admin role removed.",
  "Administrator": "Administrator",
  "Administratoren der Plattform": "Platform administrators",
  "Adresse": "Address",
  "Adresse (optional)": "Address (optional)",
  "Airbnb": "Airbnb",
  "Aktion nicht möglich (ggf. eigenes Konto).": "Action not possible (possibly your own account).",
  "Aktionen": "Actions",
  "aktiv": "enabled",
  "Aktiv": "Active",
  "Aktivität": "Activity",
  "Aktualisieren": "Update",
  "Aktualisieren fehlgeschlagen. Bitte versuche es später erneut.": "Update failed. Please try again later.",
  "Aktualisiert am": "Updated at",
  "Alle": "All",
  "Alle Aktivitäten": "All activities",
  "Alle Datensätze dieser Quelle werden dieser Region zugeordnet.": "Every record from this source is assigned to this region.",
  "Alle Einträge aus „{log}“ wurden gelöscht.": "All entries in “{log}” were deleted.",
  "Alle Einträge löschen?": "Delete all entries?",
  "Alle Kategorien": "All categories",
  "Alle kommenden": "All upcoming",
  "Alle Längen": "All distances",
  "Alle löschen": "Delete all",
  "Alle Quellen": "All sources",
  "Alle Tenants auf einen Blick.": "Every tenant at a glance.",
  "Alle Unterkünfte der Plattform": "Every accommodation on the platform",
  "Allgemein": "General",
  "Als Dublette erkannt": "Detected as a duplicate",
  "Als Empfehlung hervorheben": "Highlight as a recommendation",
  "als Entwurf": "as draft",
  "Analytics": "Analytics",
  "Anbieter liefern unbearbeitete Originale (im Schnitt 1,5 MB, teils über 70 MB). Beim Kopieren werden sie auf diese Kantenlänge verkleinert und als WebP gespeichert.": "Providers deliver unprocessed originals (1.5 MB on average, sometimes over 70 MB). When copied, they are scaled down to this edge length and stored as WebP.",
  "Anbieter-ID": "Provider ID",
  "Anbieter-Seite": "Provider page",
  "Anfahrt": "Directions",
  "Anfragen": "requests",
  "Angemeldet bleiben": "Stay signed in",
  "Anlegen": "Create",
  "Anlegen fehlgeschlagen. Bitte versuche es später erneut.": "Creating failed. Please try again later.",
  "Anmelden": "Sign in",
  "Anmeldung fehlgeschlagen. Bitte versuche es später erneut.": "Sign-in failed. Please try again later.",
  "Ansehen": "View",
  "Apartment": "Apartment",
  "API-Anfragen": "API requests",
  "Architektur": "Architecture",
  "Archiviert": "Archived",
  "Archiviert — aus dem Feed entfernt": "Archived — removed from the feed",
  "Asphalt": "Paved",
  "Aufenthalte": "Stays",
  "Aufstieg": "Ascent",
  "aus der Quelle": "from the source",
  "Ausblenden": "Hide",
  "Ausflugsziele, Aussichtspunkte und Museen der Region": "Attractions, viewpoints and museums in the region",
  "Aussichtspunkt": "Viewpoint",
  "Auswahl aufheben": "Clear selection",
  "automatisch": "automatic",
  "B&B": "B&B",
  "Bäckerei": "Bakery",
  "Bad & Badestelle": "Pool & bathing spot",
  "Bar": "Bar",
  "Barrierefreies WC": "Accessible toilet",
  "Barrierefreiheit": "Accessibility",
  "Basis": "Basics",
  "Bearbeiten": "Edit",
  "Behalte den Überblick über alle Gastgeber, Tenants und Regionen — an einem Ort.": "Keep track of every host, tenant and region — in one place.",
  "beim Anbieter verlinkt": "linked from the provider",
  "Beim nächsten Import werden alle manuellen Änderungen an dieser Veranstaltung durch die Daten der Quelle ersetzt.": "On the next import, every manual change to this event will be replaced by the source's data.",
  "Beim Speichern wird die Veranstaltung gegen den täglichen Import gesperrt, damit deine Änderungen erhalten bleiben.": "Saving locks the event against the daily import so your changes are kept.",
  "BELTURO Cloud — Interner Operator-Zugang.": "BELTURO Cloud — internal operator access.",
  "BELTURO Plattform": "BELTURO platform",
  "Benachrichtigungen": "Notifications",
  "Benutzer": "Users",
  "Benutzer konnten nicht geladen werden": "Users could not be loaded",
  "Benutzer löschen?": "Delete user?",
  "Benutzer wurde gelöscht.": "User deleted.",
  "Benutzer wurde nicht gefunden.": "User not found.",
  "Benutzerdetails": "User details",
  "Benutzern": "users",
  "Berghütte": "Mountain hut",
  "Beschreibung": "Description",
  "Bewertungen": "Reviews",
  "Biergarten": "Beer garden",
  "Bilder": "Images",
  "Bilder in unseren Speicher kopieren statt zu verlinken": "Copy images into our storage instead of linking them",
  "Bio": "Organic",
  "bis": "to",
  "bis {km} km": "up to {km} km",
  "Bitte gib dein Passwort ein.": "Please enter your password.",
  "Bitte gib eine E-Mail-Adresse ein.": "Please enter an email address.",
  "Bitte gib eine gültige E-Mail-Adresse ein.": "Please enter a valid email address.",
  "Bitte gib eine gültige URL ein (inkl. https://).": "Please enter a valid URL (including https://).",
  "Bitte gib einen Firmennamen ein.": "Please enter a company name.",
  "Bitte gib einen Namen ein.": "Please enter a name.",
  "Bitte gib einen Slug (Subdomain) ein.": "Please enter a slug (subdomain).",
  "Bitte gib einen Titel ein.": "Please enter a title.",
  "Bitte höchstens {count} Zeichen eingeben.": "Please enter at most {count} characters.",
  "Bitte mindestens {count} Zeichen eingeben.": "Please enter at least {count} characters.",
  "Bitte überprüfe das Format dieser Eingabe.": "Please check the format of this entry.",
  "Bitte überprüfe deine Eingaben.": "Please check your entries.",
  "Bitte versuche es später erneut.": "Please try again later.",
  "Bitte wähle einen Eigentümer (Client) aus.": "Please select an owner (client).",
  "Bitte wählen …": "Please select …",
  "Blindenführhund erlaubt": "Guide dogs welcome",
  "Bootsverleih": "Boat rental",
  "Brauerei": "Brewery",
  "Bücherei": "Library",
  "Burg & Schloss": "Castle & palace",
  "Café": "Café",
  "Camping": "Camping",
  "Client": "Client",
  "Client bearbeiten": "Edit client",
  "Client-Benutzer „{name}“ wurde aktualisiert.": "Client user “{name}” was updated.",
  "Client-Benutzer „{name}“ wurde angelegt.": "Client user “{name}” was created.",
  "Client-Rolle entfernen?": "Remove client role?",
  "Client-Rolle wurde entfernt.": "Client role removed.",
  "Clients": "Clients",
  "Clients der Plattform": "Clients of the platform",
  "Club": "Club",
  "Das Passwort muss mindestens 6 Zeichen lang sein.": "The password must be at least 6 characters long.",
  "Daten": "Data",
  "Datenquelle bearbeiten": "Edit data source",
  "Datenquellen": "Data sources",
  "Datenquellen konnten nicht geladen werden": "Data sources could not be loaded",
  "Datentyp beim Anbieter": "Provider's record type",
  "Dauer": "Duration",
  "Dauerhaft geschlossen": "Permanently closed",
  "Debug": "Debug",
  "Deine Sitzung wurde sicher beendet. Bis bald!": "Your session was ended securely. See you soon!",
  "Denkmal": "Monument",
  "Der Datenpool, den der Lizenzschlüssel freischaltet.": "The data pool the licence key unlocks.",
  "Der Eintrag wurde nicht gefunden.": "The entry was not found.",
  "Detail": "Detail",
  "Details": "Details",
  "Di": "Tue",
  "Die Änderung wurde abgelehnt.": "The change was rejected.",
  "Die Karte konnte nicht geladen werden. Der Streckenverlauf wird als Skizze angezeigt.": "The map could not be loaded. The route is shown as a sketch.",
  "Die Quelle konnte nicht abgefragt werden. Details stehen an der Quelle.": "The source could not be queried. Details are on the source.",
  "Die Quelle wurde nicht gefunden.": "The source was not found.",
  "Die Tour wurde nicht gefunden.": "The tour was not found.",
  "Die Veranstaltung folgt wieder ihrer Quelle.": "The event follows its source again.",
  "Die Veranstaltung wird Gästen wieder angezeigt und beim nächsten Import nicht erneut automatisch zugeordnet.": "The event will be shown to guests again and will not be matched automatically on the next import.",
  "Die Veranstaltung wird wieder angezeigt.": "The event is shown again.",
  "Die Veranstaltung wurde nicht gefunden.": "The event was not found.",
  "Diese E-Mail-Adresse wird bereits verwendet.": "This email address is already in use.",
  "Diese Quelle liefert für diese Veranstaltung keine Bilder.": "This source provides no images for this event.",
  "Diese Tour ist gegen den Import gesperrt.": "This tour is locked against the import.",
  "Diese Veranstaltung wurde bereits über eine andere Quelle importiert und wird Gästen deshalb nicht angezeigt. Wenn es sich doch um eine eigenständige Veranstaltung handelt, lässt sich die Verknüpfung aufheben — sie wird dann sichtbar und künftig nicht mehr automatisch zugeordnet.": "This event was already imported from another source and is therefore hidden from guests. If it is in fact a separate event, the link can be released — it then becomes visible and will no longer be matched automatically.",
  "Diese Veranstaltung wurde manuell bearbeitet und wird vom täglichen Import nicht mehr überschrieben.": "This event was edited by hand and is no longer overwritten by the daily import.",
  "dieser Benutzer": "this user",
  "Dieser Eintrag ist gegen den Import gesperrt.": "This entry is locked against the import.",
  "Dieser Slug ist bereits vergeben.": "This slug is already taken.",
  "Dieses Feld ist erforderlich.": "This field is required.",
  "Distanz": "Distance",
  "Do": "Thu",
  "Draußen": "Outdoors",
  "Du bist abgemeldet": "You are signed out",
  "Du wirst im Client-Admin von \"{name}\" automatisch als dessen Eigentümer angemeldet.": "You will be signed in automatically as the owner of \"{name}\" in the client admin.",
  "Dublette": "Duplicate",
  "Dublette — diese Tour existiert bereits und wird Gästen nicht angezeigt": "Duplicate — this tour already exists and is hidden from guests",
  "Dublette — diese Veranstaltung kam bereits über eine andere Quelle und wird Gästen nicht angezeigt": "Duplicate — this event already arrived from another source and is hidden from guests",
  "Dublette — dieser Eintrag existiert bereits und wird Gästen nicht angezeigt": "Duplicate — this entry already exists and is hidden from guests",
  "Dublette — dieser Eintrag kam bereits über eine andere Quelle und wird Gästen nicht angezeigt": "Duplicate — this entry already arrived from another source and is hidden from guests",
  "Dubletten": "Duplicates",
  "Dubletten anderer Quellen erkennen": "Detect duplicates from other sources",
  "E-Mail": "Email",
  "E-Mail (optional)": "Email (optional)",
  "Eigentümer": "Owner",
  "Eigentümer (Client)": "Owner (client)",
  "Eine Änderung sperrt den Eintrag gegen den nächsten Import.": "A change locks the entry against the next import.",
  "Eine Änderung sperrt die Tour gegen den nächsten Import.": "A change locks the tour against the next import.",
  "Eine Plattform.": "One platform.",
  "Einen Moment bitte.": "One moment please.",
  "Einstellungen": "Settings",
  "Eintrag": "Entry",
  "Eintrag konnte nicht geladen werden.": "The entry could not be loaded.",
  "Einträge": "entries",
  "Einträge pro Abruf": "Entries per request",
  "Einträgen": "entries",
  "Eisdiele": "Ice cream parlour",
  "Endgültig löschen": "Delete permanently",
  "Endpunkt (URL)": "Endpoint (URL)",
  "Entwurf": "Draft",
  "Entwurf — nicht sichtbar": "Draft — not visible",
  "erfolgreich": "successful",
  "Ernährung": "Dietary",
  "Erscheint auf der Karte in der Gäste-App.": "Appears on the card in the guest app.",
  "Erstellt am": "Created at",
  "Es liegen keine API-Anfragen vor.": "There are no API requests.",
  "Es liegen keine Systemprotokoll-Einträge vor.": "There are no system log entries.",
  "Es werden die ersten {limit} Einträge angezeigt. Grenze die Auswahl über die Filter weiter ein.": "Showing the first {limit} entries. Narrow the selection with the filters.",
  "Es werden die ersten {limit} Touren angezeigt. Grenze die Auswahl über die Filter weiter ein.": "Showing the first {limit} tours. Narrow the selection with the filters.",
  "Es werden die ersten {limit} Veranstaltungen angezeigt. Grenze die Auswahl über die Filter weiter ein.": "Showing the first {limit} events. Narrow the selection with the filters.",
  "Es wurden keine Benutzer mit der Rolle „admin“ gefunden.": "No users with the “admin” role were found.",
  "Externe Schnittstellen, aus denen BELTURO regionale Inhalte importiert": "External interfaces BELTURO imports regional content from",
  "Externe Schnittstellen, aus denen BELTURO regionale Inhalte importiert — derzeit Veranstaltungen, später auch Sehenswürdigkeiten und Gastronomie. Der Import läuft künftig täglich automatisch — hier lässt er sich jederzeit manuell anstoßen.": "External interfaces BELTURO imports regional content from — currently events, later also sights and restaurants. The import will run automatically every day; here it can be triggered manually at any time.",
  "Feature-Flags": "Feature flags",
  "Fehler": "Error",
  "Fehler beim Laden der Daten": "Error loading the data",
  "fehlgeschlagen": "failed",
  "Fels": "Rock",
  "Findet draußen statt (wetterabhängig)": "Takes place outdoors (weather-dependent)",
  "Firmenname": "Company name",
  "Fr": "Fri",
  "Freizeit": "Leisure",
  "Frühling": "Spring",
  "Führung": "Guided tour",
  "Für diese Auswahl liegen keine Daten vor. Der Import läuft über „Datenquellen“.": "There is no data for this selection. The import runs from “Data sources”.",
  "Galerie": "Gallery",
  "ganztägig": "all day",
  "Gast": "Guest",
  "Gästehaus": "Guesthouse",
  "Gästekonten": "Guest accounts",
  "Gastgeber": "Hosts",
  "Gastgeber (Client-Rolle)": "Hosts (client role)",
  "Gastronomie": "Restaurants",
  "Gastronomie konnte nicht geladen werden": "Restaurants could not be loaded",
  "Gebannt": "Banned",
  "Geeignet für": "Suitable for",
  "Geotop": "Geotope",
  "Gesamt": "Total",
  "Geschäft": "Shop",
  "Geschützter Bereich": "Protected area",
  "Gesperrt": "Blocked",
  "Ghost-Session konnte nicht gestartet werden.": "The ghost session could not be started.",
  "Ghost-Session starten": "Start ghost session",
  "Ghost-Session starten?": "Start ghost session?",
  "Glutenfrei": "Gluten-free",
  "Guests": "Guests",
  "Halal": "Halal",
  "Herbst": "Autumn",
  "Herkunft": "Provenance",
  "Hilfe & Support": "Help & support",
  "Hin und zurück": "Out and back",
  "Hinweise": "Notes",
  "Historische Stätte": "Historic site",
  "Historischer Kern": "Historic centre",
  "Hofladen": "Farm shop",
  "Höhe": "Altitude",
  "Höhle": "Cave",
  "Home": "Home",
  "Höranlage": "Hearing loop",
  "Hostel": "Hostel",
  "Hotel": "Hotel",
  "Hunde erlaubt": "Dogs allowed",
  "Import": "Import",
  "Import abgeschlossen — {stats}": "Import finished — {stats}",
  "Import fehlgeschlagen. Bitte versuche es später erneut.": "Import failed. Please try again later.",
  "Import läuft …": "Import running …",
  "Importiert aus „{source}“": "Imported from “{source}”",
  "Importierte Veranstaltungen sofort veröffentlichen": "Publish imported events immediately",
  "in BELTURO gespeichert": "stored in BELTURO",
  "inaktiv": "disabled",
  "Info": "Info",
  "Inhalt": "Content",
  "Inhalte": "Entries",
  "Interner Operator-Zugang": "Internal operator access",
  "Ja": "Yes",
  "Jahreszeiten": "Seasons",
  "Jetzt importieren": "Import now",
  "Kanu": "Canoeing",
  "Kategorie": "Category",
  "Kein Konto mit dieser E-Mail-Adresse gefunden.": "No account found for this email address.",
  "Kein Streckenverlauf hinterlegt": "No route track stored",
  "Kein Termin": "No date",
  "Kein Zugang? Wende dich an die BELTURO-Administration.": "No access? Get in touch with BELTURO administration.",
  "Keine Admin-Benutzer": "No admin users",
  "Keine Angaben": "No details",
  "Keine Benutzer gefunden": "No users found",
  "Keine Berechtigung für diese Aktion.": "No permission for this action.",
  "Keine Client-Benutzer verfügbar": "No client users available",
  "Keine Datenquellen": "No data sources",
  "Keine Datenquellen eingerichtet": "No data sources set up",
  "Keine Dublette — wieder anzeigen": "Not a duplicate — show again",
  "Keine Dublette?": "Not a duplicate?",
  "Keine Einträge": "No entries",
  "Keine Einträge gefunden": "No entries found",
  "Keine Gastronomie gefunden": "No restaurants found",
  "Keine Gastronomie oder Sehenswürdigkeiten innerhalb von {radius} entlang der Strecke.": "No restaurants or sights within {radius} of the route.",
  "Keine Kartenquelle konfiguriert — der Streckenverlauf wird als Skizze angezeigt. Kachel-URL in config.json unter „map.tileUrl“ hinterlegen.": "No map source configured — the route is shown as a sketch. Set a tile URL in config.json under “map.tileUrl”.",
  "Keine Sehenswürdigkeiten gefunden": "No sights found",
  "Keine Termine hinterlegt.": "No dates stored.",
  "Keine Touren gefunden": "No tours found",
  "Keine Unterkünfte": "No accommodations",
  "Keine Unterkünfte gefunden": "No accommodations found",
  "Keine Veranstaltungen gefunden": "No events found",
  "Kennzahlen konnten nicht geladen werden": "Key figures could not be loaded",
  "Kennzahlen zu Gastgebern, Unterkünften und den regionalen Inhalten, die allen Gästemappen zugrunde liegen.": "Key figures on hosts, accommodations and the regional content behind every guest directory.",
  "KI-Kosten": "AI costs",
  "Kinderwagentauglich": "Pushchair-friendly",
  "Kino": "Cinema",
  "Kirche": "Church",
  "Klettern": "Climbing",
  "Kloster": "Monastery",
  "Kontakt": "Contact",
  "Konten": "Accounts",
  "Koordinaten": "Coordinates",
  "kopiert · max. {px} px": "copied · max. {px} px",
  "Kopiert werden nur Bilder mit einer passenden Lizenz (CC0, CC-BY, CC-BY-SA) — jeweils mit Bildnachweis. Alle anderen bleiben beim Anbieter verlinkt.": "Only images with a suitable licence (CC0, CC-BY, CC-BY-SA) are copied — each with its credit. All others stay linked from the provider.",
  "Kritisch": "Critical",
  "Küche": "Cuisine",
  "Küche & Ausstattung": "Cuisine & facilities",
  "Kultur & Geschichte": "Culture & history",
  "Kurztext": "Teaser",
  "Lade API-Anfragen …": "Loading API requests …",
  "Lade Benutzer …": "Loading users …",
  "Lade Datenquellen …": "Loading data sources …",
  "Lade Gastronomie …": "Loading restaurants …",
  "Lade Kennzahlen …": "Loading key figures …",
  "Lade Sehenswürdigkeiten …": "Loading sights …",
  "Lade Systemprotokoll …": "Loading system log …",
  "Lade Touren …": "Loading tours …",
  "Lade Unterkünfte …": "Loading accommodations …",
  "Lade Veranstaltungen …": "Loading events …",
  "Lädt …": "Loading …",
  "Laktosefrei": "Lactose-free",
  "Ländercode": "Country code",
  "Langlauf": "Cross-country skiing",
  "Laufen": "Running",
  "Leer lassen, um beizubehalten": "Leave empty to keep",
  "Leer lassen, um den gespeicherten Schlüssel unverändert zu übernehmen.": "Leave empty to keep the stored key unchanged.",
  "Leicht": "Easy",
  "Letzter Import {date} · {status}": "Last import {date} · {status}",
  "Level": "Level",
  "Links & Hervorhebung": "Links & highlighting",
  "Lizenzschlüssel": "Licence key",
  "Löschen": "Delete",
  "Löschen fehlgeschlagen. Bitte versuche es später erneut.": "Deleting failed. Please try again later.",
  "Manuell bearbeitet": "Edited by hand",
  "Manuell bearbeitet — wird beim Import nicht überschrieben": "Edited by hand — not overwritten by the import",
  "Maschinell übersetzt": "Machine-translated",
  "Mausrad-Zoom ist aus, damit der Dialog scrollbar bleibt — nutze die +/− Schaltflächen.": "Scroll-wheel zoom is off so the dialog stays scrollable — use the +/− buttons.",
  "Max Mustermann": "Jane Doe",
  "Max. Abrufe": "Max. requests",
  "Maximale Bildkante (px)": "Maximum image edge (px)",
  "Mein Profil": "My profile",
  "Melde dich an, um die BELTURO-Plattform zu verwalten.": "Sign in to manage the BELTURO platform.",
  "Menü öffnen": "Open menu",
  "Methode": "Method",
  "Mi": "Wed",
  "Mindestens 6 Zeichen": "At least 6 characters",
  "Mit anzeigen": "Show as well",
  "mit Fehlern": "with errors",
  "Mittel": "Moderate",
  "Mo": "Mon",
  "Möchtest du wirklich alle Einträge aus „{log}“ unwiderruflich löschen? Diese Aktion kann nicht rückgängig gemacht werden.": "Do you really want to permanently delete every entry in “{log}”? This action cannot be undone.",
  "Mountainbike": "Mountain biking",
  "Mühle": "Mill",
  "Museum": "Museum",
  "Musterhotel": "Sample Hotel",
  "Musterhotel GmbH": "Sample Hotel Ltd",
  "Nach Import": "After import",
  "Nachricht": "Message",
  "Nächste 180 Tage": "Next 180 days",
  "Nächste 30 Tage": "Next 30 days",
  "Nächste 90 Tage": "Next 90 days",
  "Nächster Termin": "Next date",
  "Name": "Name",
  "Name des Ortes": "Venue name",
  "Natur": "Nature",
  "Naturinformation": "Nature information",
  "Natursehenswürdigkeit": "Natural landmark",
  "Neue Unterkunft anlegen": "Create accommodation",
  "Neuen Admin anlegen": "Create admin",
  "Neuen Client anlegen": "Create client",
  "Nicht verifiziert": "Not verified",
  "noch kein Import": "no import yet",
  "Noch kein Import gelaufen": "No import has run yet",
  "Noch keine Feeds eingerichtet.": "No feeds set up yet.",
  "Noch keine Übersetzungen vorhanden.": "No translations yet.",
  "noch nicht hinterlegt": "not stored yet",
  "noch nie": "never",
  "Nur Dubletten": "Duplicates only",
  "Nur Kleinbuchstaben, Ziffern und Bindestriche. Muss eindeutig sein.": "Lowercase letters, digits and hyphens only. Must be unique.",
  "Nur veröffentlichte Unterkünfte sind für Gäste sichtbar (Guest-App & Gästemappe).": "Only published accommodations are visible to guests (guest app & guest directory).",
  "Öffnungszeiten": "Opening hours",
  "Ohne Angabe": "Not specified",
  "ohne Begrenzung": "no limit",
  "Operator": "Operator",
  "Original": "Original",
  "Original ansehen": "View original",
  "Ort": "Place",
  "Park & Garten": "Park & garden",
  "Parkmöglichkeit": "Parking",
  "Parkplätze": "Parking spaces",
  "Passwort": "Password",
  "Passwort anzeigen": "Show password",
  "Passwort verbergen": "Hide password",
  "Passwort vergessen?": "Forgot your password?",
  "Pfad": "Path",
  "Pilgerweg": "Pilgrimage",
  "Plattform-Administratoren": "Platform administrators",
  "Plattform-Operator": "Platform operator",
  "Plattform-Pool, ohne Duplikate": "Platform pool, duplicates excluded",
  "Plattform-Status auf einen Blick": "Platform status at a glance",
  "Plattform-Verwaltung": "Platform administration",
  "PLZ": "Postcode",
  "Preis": "Price",
  "Preisangabe": "Price note",
  "Preisniveau": "Price level",
  "Protokoll konnte nicht geladen werden": "The log could not be loaded",
  "Protokolle": "Logs",
  "Quelle": "Source",
  "Quelle aktiv — wird beim täglichen Import berücksichtigt": "Source enabled — included in the daily import",
  "Quellen werden zusammen mit ihrem Importer ausgeliefert.": "Sources ship together with their importer.",
  "Radfahren": "Cycling",
  "Rechnungen": "Invoices",
  "Redaktionell gepflegte Veranstaltung der Plattform": "Editorially curated platform event",
  "Region": "Region",
  "Regional": "Regional",
  "Regionale Inhalte": "Regional content",
  "Regionale Veranstaltungen der Plattform": "Regional events on the platform",
  "Reiten": "Horse riding",
  "Rennrad": "Road cycling",
  "Reservieren": "Book a table",
  "Reservierung": "Reservation",
  "Restaurant": "Restaurant",
  "Restaurants, Cafés und Bars der Region": "Restaurants, cafés and bars in the region",
  "Rolle entfernen": "Remove role",
  "Rolle:": "Role:",
  "Rollen": "Roles",
  "Rollstuhlgerecht": "Wheelchair accessible",
  "Ruine": "Ruin",
  "Rundweg": "Loop",
  "Rundweg — zurück zum Start": "Loop — back to the start",
  "Sa": "Sat",
  "Sächsische Schweiz": "Saxon Switzerland",
  "Schätzung nach Listenpreis": "Estimate at list price",
  "Schließen": "Close",
  "Schlüssel, Adapter und Inhaltstyp sind fest — an ihnen hängen alle bereits importierten Datensätze.": "Key, adapter and content type are fixed — every record already imported hangs off them.",
  "Schneeschuh": "Snowshoeing",
  "Schotter": "Gravel",
  "Schwer": "Hard",
  "Schwierigkeit": "Difficulty",
  "See": "Lake",
  "Sehenswertes": "Points of interest",
  "Sehenswürdigkeit": "Sight",
  "Sehenswürdigkeiten": "Sights",
  "Sehenswürdigkeiten konnten nicht geladen werden": "Sights could not be loaded",
  "Sehr schwer": "Very hard",
  "Seitenleiste ein-/ausklappen": "Collapse/expand sidebar",
  "Service": "Services",
  "Sicherheit": "Security",
  "Sitzplätze": "Seating",
  "Slug": "Slug",
  "Slug (Subdomain)": "Slug (subdomain)",
  "So": "Sun",
  "Sommer": "Summer",
  "Sonstige": "Other",
  "Sonstiges": "Other",
  "Spazieren": "Walking",
  "Speichern": "Save",
  "Speichern fehlgeschlagen. Bitte versuche es später erneut.": "Saving failed. Please try again later.",
  "Spezialitäten": "Specialities",
  "Spielplatz": "Playground",
  "Sport": "Sports",
  "Sprache": "Language",
  "Stadt": "City",
  "Stadtrundgang": "City walk",
  "Stadtteil": "District",
  "Start": "Start",
  "Start & Ziel": "Start & finish",
  "Startadresse": "Start address",
  "Status": "Status",
  "Straße": "Street",
  "Straße & Nr.": "Street & no.",
  "Streckentour": "Point to point",
  "Streckenverlauf": "Route",
  "Stufenlos": "Step-free",
  "Suchen …": "Search …",
  "Synchronisieren": "Synchronise",
  "System": "System",
  "System- und API-Protokolle": "System and API logs",
  "Systemprotokoll": "System log",
  "Systemzustand": "System health",
  "Telefon": "Phone",
  "Telefon (optional)": "Phone (optional)",
  "Termine": "Dates",
  "Theater & Bühne": "Theatre & stage",
  "Ticket-Link": "Ticket link",
  "Titel": "Title",
  "Titelbild": "Cover image",
  "Tour": "Tour",
  "Tour konnte nicht geladen werden.": "The tour could not be loaded.",
  "Touren": "Tours",
  "Touren konnten nicht geladen werden": "Tours could not be loaded",
  "Tourist-Information": "Tourist information",
  "Track herunterladen": "Download track",
  "Typ": "Type",
  "Übersetzungen": "Translations",
  "Übersicht": "Overview",
  "Übersicht.": "Overview.",
  "Um den Mittelpunkt der Region. Leer = alles übernehmen.": "Around the centre of the region. Empty = take everything.",
  "Umkreis": "Radius",
  "Umkreis (km)": "Radius (km)",
  "unbekannt": "unknown",
  "unbekannter Quelle": "an unknown source",
  "Ungültige Eingabe.": "Invalid entry.",
  "Ungültiger Slug. Erlaubt: Kleinbuchstaben, Ziffern, Bindestriche.": "Invalid slug. Allowed: lowercase letters, digits, hyphens.",
  "Untergrund": "Surface",
  "Unterkunft „{name}“ wurde aktualisiert.": "Accommodation “{name}” was updated.",
  "Unterkunft „{name}“ wurde angelegt.": "Accommodation “{name}” was created.",
  "Unterkunft bearbeiten": "Edit accommodation",
  "Unterkunft wurde nicht gefunden.": "Accommodation not found.",
  "Unterkunft-Details": "Accommodation details",
  "Unterkünfte": "Accommodations",
  "Unterkünfte konnten nicht geladen werden": "Accommodations could not be loaded",
  "Unterkünfte veröffentlicht": "Accommodations published",
  "Unterkünften": "accommodations",
  "Untertitel": "Subtitle",
  "Vegan": "Vegan",
  "Vegetarisch": "Vegetarian",
  "Veranstaltung bearbeiten": "Edit event",
  "Veranstaltung konnte nicht geladen werden.": "The event could not be loaded.",
  "Veranstaltungen": "Events",
  "Veranstaltungen konnten nicht geladen werden": "Events could not be loaded",
  "Veranstaltungen, die eine andere Quelle bereits geliefert hat, werden erkannt (Titel, Datum und Ort) und Gästen nur einmal angezeigt. Beide Datensätze bleiben erhalten.": "Events another source already delivered are detected (title, date and place) and shown to guests only once. Both records are kept.",
  "Veranstaltungsort": "Event venue",
  "Verbindung": "Connection",
  "Vergangene einschließen": "Include past",
  "Verkehr": "Transport",
  "Verknüpfter Eintrag": "Linked entry",
  "verlinkt": "linked",
  "Veröffentlichen": "Publish",
  "veröffentlicht": "published",
  "Veröffentlicht": "Published",
  "Veröffentlicht — in der Gäste-App sichtbar": "Published — visible in the guest app",
  "Verschoben": "Postponed",
  "Verteilung": "Distribution",
  "Vertex AI · letzte 3 Monate": "Vertex AI · last 3 months",
  "Verwalten": "Manage",
  "Viele Regionen.": "Many regions.",
  "von": "of",
  "Wander-, Rad- und Themenwege der Region": "Hiking, cycling and themed routes in the region",
  "Wandern": "Hiking",
  "Warnung": "Warning",
  "Wasserfall": "Waterfall",
  "WC": "Toilet",
  "Webseite": "Website",
  "Webseite (optional)": "Website (optional)",
  "Website": "Website",
  "Wegbeschaffenheit": "Trail conditions",
  "Wegpunkt": "Waypoint",
  "Wegpunkte": "Waypoints",
  "Weingut": "Winery",
  "Weiter": "Next",
  "Wellness & Sauna": "Wellness & sauna",
  "Wieder anzeigen": "Show again",
  "Wieder mit der Quelle synchronisieren": "Synchronise with the source again",
  "Wieder mit der Quelle synchronisieren?": "Synchronise with the source again?",
  "Wiese": "Grass",
  "Willkommen zurück": "Welcome back",
  "Winter": "Winter",
  "Winterwandern": "Winter hiking",
  "Zeige": "Showing",
  "Zeitpunkt": "Timestamp",
  "Zeitraum": "Period",
  "Zeitraum (Monate)": "Period (months)",
  "Zeitzone": "Time zone",
  "Ziel": "Finish",
  "Zoo & Tierpark": "Zoo & wildlife park",
  "Zugang verweigert. Prüfe deine Zugangsdaten oder Berechtigung.": "Access denied. Check your credentials or permissions.",
  "zuletzt abgeglichen {date}": "last synced {date}",
  "Zuletzt geändert": "Last changed",
  "Zuletzt synchronisiert": "Last synced",
  "Zurück": "Previous",
  "Zurück zur Anmeldung": "Back to sign-in",
  "Zurückziehen": "Unpublish",
  "Nutzung der Gäste-Apps aller Unterkünfte": "Guest app usage across all accommodations",
  "Lade Analytics …": "Loading analytics …",
  "Analytics konnten nicht geladen werden.": "Analytics could not be loaded.",
  "{days} Tage": "{days} days",
  "Besucher": "Visitors",
  "Besuche": "Visits",
  "Seitenaufrufe": "Page views",
  "Aktive Unterkünfte": "Active accommodations",
  "mit Besuchern im Zeitraum": "with visitors in this period",
  "Besucher pro Woche": "Visitors per week",
  "Besucher pro Tag": "Visitors per day",
  "Besucher im Zeitverlauf": "Visitors over time",
  "Ø Besucher pro Wochentag": "Avg. visitors per weekday",
  "Besucher nach Uhrzeit": "Visitors by time of day",
  "{n} Aufrufe": "{n} views",
  "Gelöschte Unterkunft": "Deleted accommodation",
  "Kein Vergleich zum Vorzeitraum": "No previous period to compare",
  "Noch keine Daten": "No data yet",
  "Wie im Vorzeitraum": "Same as previous period",
  "{change} zum Vorzeitraum": "{change} vs. previous period",
  "Woche ab {date}": "Week of {date}",
  "{from}–{to} Uhr": "{from}:00–{to}:00",
  "Startseite": "Home",
  "Gästemappe": "Guest directory",
  "Empfehlungen": "Recommendations",
  "Aufenthaltsplaner": "Stay planner",
  "Chat": "Chat",
  "Umfragen": "Surveys",
  "Wellness": "Wellness",
  "Noch keine Nutzungsdaten in diesem Zeitraum. Die Zahlen werden stündlich aus den Gäste-Apps verdichtet.": "No usage data in this period yet. The figures are rolled up hourly from the guest apps.",
  "Meistgenutzte Unterkünfte": "Most used accommodations",
  "Unterkunft": "Accommodation",
  "Beliebteste Bereiche": "Most popular sections",
  "Noch keine Aufrufe.": "No views yet.",
  "Anonym gezählt, ein Besucher je Tag und Unterkunft. Uhrzeit und Tag in der Zeitzone der jeweiligen Unterkunft.": "Counted anonymously, one visitor per day and accommodation. Time and day in each accommodation's time zone.",
  "Stand: {date}": "As of {date}",
  "bis jetzt": "so far",
  "Lade Gästekonten …": "Loading guest accounts …",
  "Gästekonten konnten nicht geladen werden": "Guest accounts could not be loaded",
  "E-Mail bestätigt": "Email confirmed",
  "In einer Unterkunft angemeldet": "Signed in at an accommodation",
  "Haben geschrieben": "Have written",
  "Nachrichten": "Messages",
  "Pläne": "Plans",
  "Zuletzt aktiv": "Last active",
  "Registriert": "Registered",
  "Keine Gästekonten gefunden": "No guest accounts found",
  "Registrierte Gäste der Plattform": "Registered guests of the platform",
  "Lade Gästekonto …": "Loading guest account …",
  "Gästekonto nicht gefunden": "Guest account not found",
  "Gästekonto konnte nicht geladen werden": "Guest account could not be loaded",
  "Dieses Konto gibt es nicht (mehr) oder es ist kein Gästekonto.": "This account does not exist (any more) or is not a guest account.",
  "Alle Gästekonten": "All guest accounts",
  "Gästekonto": "Guest account",
  "Per Link": "Via link",
  "Per QR-Code": "Via QR code",
  "Im Chat": "In the chat",
  "Aus der Gäste-App": "From the guest app",
  "Per Benachrichtigung": "Via notification",
  "Konto-ID": "Account ID",
  "Nachrichten vom Gast": "Messages from the guest",
  "Pläne im Planer": "Plans in the planner",
  "Umfrage-Einladungen": "Survey invitations",
  "Chat-Verlauf": "Chat history",
  "Dieser Gast hat noch mit keiner Unterkunft gechattet.": "This guest has not chatted with any accommodation yet.",
  "Chat mit {house}": "Chat with {house}",
  "{count} ungelesen": "{count} unread",
  "Noch keine Nachrichten.": "No messages yet.",
  "KI-Concierge": "AI concierge",
  "Noch in keiner Unterkunft angemeldet.": "Not signed in at any accommodation yet.",
  "Erstmals {first} · zuletzt {last}": "First {first} · last {last}",
  "Aufenthalte (Planer)": "Stays (planner)",
  "Noch keinen Aufenthalt im Planer angelegt.": "No stay created in the planner yet.",
  "{count} Einträge": "{count} entries",
  "Umfragen & Bewertungen": "Surveys & ratings",
  "Keine Umfrage-Einladungen.": "No survey invitations.",
  "Abgeschlossen": "Completed",
  "Geöffnet": "Opened",
  "Gesendet": "Sent",
  "Antworten werden nicht pro Gast angezeigt: Die Gäste-App sichert zu, dass Bewertungen für den Gastgeber anonym sind.": "Answers are not shown per guest: the guest app assures guests that ratings are anonymous to the host.",
  "Dein Konto": "Your account",
  "Das neue Passwort muss sich vom aktuellen unterscheiden.": "The new password must differ from the current one.",
  "Die Passwörter stimmen nicht überein.": "The passwords do not match.",
  "Dein Passwort wurde geändert.": "Your password has been changed.",
  "Das aktuelle Passwort stimmt nicht.": "The current password is incorrect.",
  "Das Passwort konnte nicht geändert werden. Bitte versuche es später erneut.": "The password could not be changed. Please try again later.",
  "Konto seit": "Account since",
  "Passwort ändern": "Change password",
  "Aktuelles Passwort": "Current password",
  "Neues Passwort": "New password",
  "Mindestens {count} Zeichen.": "At least {count} characters.",
  "Neues Passwort wiederholen": "Repeat new password",
  "Bestehende Anmeldungen bleiben aktiv.": "Existing sign-ins stay active.",
  "Manuell verifizieren": "Verify manually",
  "Gästekonto verifizieren?": "Verify guest account?",
  "„{email}“ wird als bestätigt markiert, ohne dass der Gast den Link aus der Bestätigungs-E-Mail geöffnet hat.": "“{email}” will be marked as confirmed without the guest having opened the link in the confirmation email.",
  "Verifizieren": "Verify",
  "„{name}“ ist jetzt verifiziert.": "“{name}” is now verified.",
  "Dieses Konto wartet nicht (mehr) auf eine Verifizierung.": "This account is not (or no longer) awaiting verification.",
  "Das Konto konnte nicht verifiziert werden. Bitte versuche es später erneut.": "The account could not be verified. Please try again later.",
  "Der Link konnte nicht angefordert werden. Bitte versuche es später erneut.": "The link could not be requested. Please try again later.",
  "Falls zu {email} ein Konto existiert, haben wir dir einen Link zum Zurücksetzen geschickt. Er ist 2 Stunden gültig.": "If an account exists for {email}, we have sent you a link to reset your password. It is valid for 2 hours.",
  "Gib die E-Mail-Adresse deines Kontos ein. Wir schicken dir einen Link, mit dem du ein neues Passwort vergeben kannst.": "Enter your account's e-mail address. We will send you a link to choose a new password.",
  "Link anfordern": "Request link",
  "Schau in dein Postfach": "Check your inbox",
  "Keine E-Mail erhalten? Prüfe deinen Spam-Ordner oder fordere den Link erneut an.": "No e-mail? Check your spam folder or request the link again.",
  "Dieser Link ist unvollständig.": "This link is incomplete.",
  "Dieser Link wurde bereits verwendet oder ist nicht mehr gültig.": "This link has already been used or is no longer valid.",
  "Dieser Link ist abgelaufen. Bitte fordere einen neuen an.": "This link has expired. Please request a new one.",
  "Dieser Link kann hier nicht verwendet werden.": "This link cannot be used here.",
  "Link ungültig": "Invalid link",
  "Link wird geprüft …": "Checking link …",
  "Neues Passwort vergeben": "Choose a new password",
  "Wähle ein neues Passwort für dein Konto.": "Choose a new password for your account.",
  "Passwort speichern": "Save password",
  "Passwort geändert": "Password changed",
  "Dein neues Passwort ist gespeichert. Aus Sicherheitsgründen wurdest du auf allen Geräten abgemeldet.": "Your new password has been saved. For security reasons you have been signed out on all devices.",
  "Zur Anmeldung": "Go to sign-in",
  "Push-Nachrichten": "Push notifications",
  "Startseite der Gäste-App": "Guest app home",
  "Region entdecken": "Explore the region",
  "Lade Push-Nachrichten …": "Loading push notifications …",
  "Die Push-Nachrichten konnten nicht geladen werden. Bitte versuche es später erneut.": "Push notifications could not be loaded. Please try again later.",
  "Titel der Nachricht": "Message title",
  "Hier steht dein Text.": "Your text goes here.",
  "Bitte gib einen Titel und eine Nachricht ein.": "Please enter a title and a message.",
  "Senden": "Send",
  "{sent} von {count} Geräten erreicht, {failed} fehlgeschlagen.": "Reached {sent} of {count} devices, {failed} failed.",
  "Nachricht an {count} Geräte gesendet.": {
    "one": "Message sent to {count} device.",
    "other": "Message sent to {count} devices."
  },
  "Bitte überprüfe Titel und Nachricht.": "Please check the title and message.",
  "Die Nachricht konnte nicht gesendet werden. Bitte versuche es später erneut.": "The message could not be sent. Please try again later.",
  "Geräte mit Benachrichtigungen": "Devices with notifications",
  "Davon mit Gäste-Konto": "With a guest account",
  "Beim Antippen öffnen": "Open on tap",
  "Keine": "None",
  "Vorschau": "Preview",
  "jetzt": "now",
  "Verlauf": "History",
  "{count} zugestellt": "{count} delivered",
  "{count} fehlgeschlagen": "{count} failed",
  "{count} abgemeldet": "{count} unsubscribed",
  "Benachrichtigungen an die Gäste aller Unterkünfte": "Notifications to the guests of every accommodation",
  "Alle Unterkünfte": "All accommodations",
  "{count} Unterkünfte ausgewählt.": {
    "one": "{count} accommodation selected.",
    "other": "{count} accommodations selected."
  },
  "Erreicht bis zu {count} Geräte": {
    "one": "Reaches up to {count} device",
    "other": "Reaches up to {count} devices"
  },
  "Bitte wähle mindestens eine Unterkunft aus.": "Please select at least one accommodation.",
  "Nachricht an die Gäste senden?": "Send the message to the guests?",
  "Die Nachricht geht sofort an alle {count} Geräte aller Unterkünfte. Das lässt sich nicht zurücknehmen.": "The message goes to all {count} devices of every accommodation right away. This cannot be undone.",
  "Die Nachricht geht sofort an {count} Geräte in {houses} Unterkünften. Das lässt sich nicht zurücknehmen.": "The message goes to {count} devices in {houses} accommodations right away. This cannot be undone.",
  "Kein Gerät hat Benachrichtigungen eingeschaltet — die Nachricht ging an niemanden.": "No device has notifications turned on — the message went to no one.",
  "Web Push ist in dieser Umgebung nicht aktiv (services.webPush in der core-api-Konfiguration). Nachrichten werden nicht zugestellt.": "Web Push is not active in this environment (services.webPush in the core-api configuration). Messages will not be delivered.",
  "Unterkünfte mit Geräten": "Accommodations with devices",
  "von {count}": "of {count}",
  "Nachricht an die Gäste": "Message to the guests",
  "z. B. Neu in deiner Gäste-App: der Aufenthaltsplaner": "e.g. New in your guest app: the stay planner",
  "Die Nachricht kommt im Namen des jeweiligen Hauses an — schreib sie so, dass sie zu jedem Haus passt.": "The message arrives in the name of each house — write it so that it fits every house.",
  "{count} Geräte": {
    "one": "{count} device",
    "other": "{count} devices"
  },
  "Ausgewählte Unterkünfte": "Selected accommodations",
  "Unterkunft suchen …": "Search accommodation …",
  "Alle mit Geräten": "All with devices",
  "Name der Unterkunft": "Accommodation name",
  "Noch keine Plattform-Nachricht gesendet. Nachrichten, die Gastgeber selbst an ihr Haus schicken, stehen hier nicht.": "No platform message sent yet. Messages hosts send to their own house are not listed here.",
  "KI-Kosten im Detail": "AI costs in detail",
  "Vertex AI · Plattform und Gastgeber": "Vertex AI · platform and hosts",
  "Lade KI-Kosten …": "Loading AI costs …",
  "KI-Kosten konnten nicht geladen werden": "AI costs could not be loaded",
  "Monat": "Month",
  "Schätzung nach Listenpreis · 1 $ = {rate} €": "Estimate at list price · $1 = €{rate}",
  "Diesen Monat": "This month",
  "Vormonat": "Previous month",
  "kein Vergleich zum Vormonat": "no previous month to compare",
  "{delta} ggü. Vormonat ({previous})": "{delta} vs. previous month ({previous})",
  "Prognose Monatsende": "Forecast end of month",
  "Prognose {amount}": "Forecast {amount}",
  "{count} Anfragen bisher": {
    "one": "{n} request so far",
    "other": "{n} requests so far"
  },
  "{n} fehlgeschlagen": "{n} failed",
  "Gastgeber / Plattform": "Hosts / platform",
  "{count} Gastgeber mit KI-Kosten": {
    "one": "{n} host with AI costs",
    "other": "{n} hosts with AI costs"
  },
  "{count} Gastgeber mit KI-Kosten in diesem Monat": {
    "one": "{n} host with AI costs this month",
    "other": "{n} hosts with AI costs this month"
  },
  "{shown} von {count} Gastgebern mit KI-Kosten · die übrigen zusammen {rest}": "{shown} of {count} hosts with AI costs · the rest together {rest}",
  "Letzte 12 Monate": "Last 12 months",
  "12 Monate": "12 months",
  "Letzte 60 Tage": "Last 60 days",
  "Kosten pro Monat": "Cost per month",
  "Kosten pro Tag": "Cost per day",
  "7-Tage-Schnitt": "7-day average",
  "Aufteilung": "Breakdown",
  "Nach Funktion": "By feature",
  "Nach Modell": "By model",
  "Nach Unterkunft": "By accommodation",
  "Top 10 Gastgeber": "Top 10 hosts",
  "In diesem Monat hatte kein Gastgeber KI-Kosten.": "No host had AI costs this month.",
  "Gastgeber ohne Namen": "Unnamed host",
  "Kosten": "Cost",
  "Monatsbudget": "Monthly budget",
  "Anteil": "Share",
  "{percent} von {budget}": "{percent} of {budget}",
  "Plattform": "Platform",
  "Plattform-eigene Kosten": "Platform's own costs",
  "Importe, nächtliche Übersetzungen, Einrichtung bei Registrierung": "Imports, nightly translations, setup at registration",
  "im Monat": "this month",
  "Keine KI-Anfragen in diesem Monat.": "No AI requests this month.",
  "Noch keine KI-Anfragen.": "No AI requests yet.",
  "Modelle": "Models",
  "Modell": "Model",
  "{input} Eingabe- und {output} Ausgabe-Tokens": "{input} input and {output} output tokens",
  "Alle KI-Kosten": "All AI costs",
  "Gastgeber nicht gefunden": "Host not found",
  "Diesen Gastgeber gibt es nicht (mehr).": "This host does not exist (anymore).",
  "Alle KI-Anfragen ohne Gastgeber: Importe, nächtliche Übersetzungen und die Einrichtung neuer Unterkünfte bei der Registrierung. Diese Kosten trägt BELTURO, sie zählen gegen kein Gastgeber-Budget.": "Every AI request without a host: imports, nightly translations and setting up new accommodations at registration. BELTURO carries these costs; they count against no host's budget.",
  "Budget diesen Monat": "Budget this month",
  "{percent} verbraucht": "{percent} used",
  "Budget aufgebraucht": "Budget used up",
  "noch {remaining} frei": "{remaining} left",
  "Ø Kosten pro Anfrage": "Avg. cost per request",
  "Ohne Unterkunft": "No accommodation",
  "Letzte Anfragen": "Latest requests",
  "die neuesten {count}": "the latest {count}",
  "Funktion": "Feature",
  "Tokens ein / aus": "Tokens in / out",
  "Übersetzung": "Translation",
  "Concierge: Dokumente lesen": "Concierge: reading documents",
  "Einrichtung bei Registrierung": "Setup at registration",
  "Gelöschter Gastgeber": "Deleted host",
  "Diesen Gastgeber gibt es nicht mehr (z. B. eine nicht abgeschlossene Registrierung). Seine KI-Anfragen bleiben in der Kostenaufstellung.": "This host no longer exists (e.g. an unfinished registration). Its AI requests stay in the cost overview.",
  "Ausgangspunkt aller Entfernungen in der Gäste-App; die Koordinaten werden beim Speichern ermittelt.": "Origin of every distance in the guest app; the coordinates are determined on save.",
  "Bitte gib Straße und Hausnummer ein.": "Please enter the street and house number.",
  "Bitte gib die PLZ ein.": "Please enter the postcode.",
  "Bitte gib den Ort ein.": "Please enter the town.",
  "Löschen ist gerade nicht möglich. Bitte versuche es später erneut.": "Deleting is not possible right now. Please try again later.",
  "Unterkunft endgültig löschen?": "Delete accommodation permanently?",
  "„{name}“ wird mit allen zugehörigen Daten unwiderruflich gelöscht — auch die Gäste-App unter {slug} ist danach nicht mehr erreichbar.": "“{name}” will be deleted irrevocably with all its data — its guest app at {slug} will no longer be available either.",
  "Dabei werden gelöscht:": "This deletes:",
  "Gastgeber ebenfalls löschen?": "Delete the host as well?",
  "„{name}“ ist die letzte Unterkunft von {owner}. Das Gastgeber-Konto wird deshalb ebenfalls gelöscht — samt Anmeldungen, und die Organisation, sobald sie leer ist.": "“{name}” is the last accommodation of {owner}. The host account will therefore be deleted too — including its sign-ins, and the organisation once it is empty.",
  "„{name}“ ist die letzte Unterkunft von {owner}. Das Konto hat weitere Rollen und bleibt bestehen; es verliert nur die Client-Rolle.": "“{name}” is the last accommodation of {owner}. The account has further roles and stays; it only loses the client role.",
  "Unterkunft und Gastgeber löschen": "Delete accommodation and host",
  "Löschen und Rolle entfernen": "Delete and remove role",
  "Unterkunft „{name}“ und ihr Gastgeber wurden gelöscht.": "Accommodation “{name}” and its host have been deleted.",
  "Unterkunft „{name}“ wurde gelöscht.": "Accommodation “{name}” has been deleted.",
  "Unterkünfte:": "Accommodations:",
  "Gastgeber endgültig löschen?": "Delete host permanently?",
  "{count} Gästemappe-Module": {
    "one": "{count} guest directory module",
    "other": "{count} guest directory modules"
  },
  "{count} eigene Veranstaltungen": {
    "one": "{count} own event",
    "other": "{count} own events"
  },
  "{count} eigene Orte": {
    "one": "{count} own place",
    "other": "{count} own places"
  },
  "{count} eigene Touren": {
    "one": "{count} own tour",
    "other": "{count} own tours"
  },
  "{count} Chat-Verläufe mit Gästen": {
    "one": "{count} guest chat",
    "other": "{count} guest chats"
  },
  "{count} Umfragen": {
    "one": "{count} survey",
    "other": "{count} surveys"
  },
  "{count} Umfrage-Antworten": {
    "one": "{count} survey answer",
    "other": "{count} survey answers"
  },
  "{count} Reisepläne von Gästen": {
    "one": "{count} guest trip plan",
    "other": "{count} guest trip plans"
  },
  "{count} Push-Abonnements": {
    "one": "{count} push subscription",
    "other": "{count} push subscriptions"
  },
  "{count} Push-Nachrichten": {
    "one": "{count} push message",
    "other": "{count} push messages"
  },
  "{count} Concierge-Dokumente": {
    "one": "{count} concierge document",
    "other": "{count} concierge documents"
  },
  "{count} Gast-Verknüpfungen": {
    "one": "{count} guest link",
    "other": "{count} guest links"
  },
  "{count} Gastkonten ohne weitere Unterkunft": {
    "one": "{count} guest account with no other accommodation",
    "other": "{count} guest accounts with no other accommodation"
  },
  "dieses Gastkonto": "this guest account",
  "Gastkonto endgültig löschen?": "Delete guest account permanently?",
  "Gast-Rolle entfernen?": "Remove guest role?",
  "„{name}“ hat nur die Gast-Rolle. Das Konto wird mit allen zugehörigen Daten unwiderruflich gelöscht und kann nicht wiederhergestellt werden.": "“{name}” only has the guest role. The account is deleted irrevocably with all its data and cannot be restored.",
  "„{name}“ hat weitere Rollen ({roles}). Es wird nur die Gast-Rolle mit den Gast-Daten entfernt; das Konto bleibt bestehen. Alle Sitzungen des Kontos werden beendet.": "“{name}” has further roles ({roles}). Only the guest role and its guest data are removed; the account stays. All of the account’s sessions are ended.",
  "Gastkonto wurde gelöscht.": "Guest account deleted.",
  "Gast-Rolle wurde entfernt.": "Guest role removed.",
  "Gastkonto wurde nicht gefunden.": "Guest account not found.",
  "{count} Unterkunfts-Verknüpfungen": {
    "one": "{count} accommodation link",
    "other": "{count} accommodation links"
  },
  "{count} Reisepläne": {
    "one": "{count} trip plan",
    "other": "{count} trip plans"
  },
  "{count} Chat-Verläufe": {
    "one": "{count} chat thread",
    "other": "{count} chat threads"
  },
  "{count} Umfrage-Einladungen": {
    "one": "{count} survey invitation",
    "other": "{count} survey invitations"
  },
  "Seite nicht gefunden": "Page not found",
  "Diese Seite gibt es nicht": "This page doesn't exist",
  "Der Link ist veraltet oder unvollständig.": "The link is outdated or incomplete.",
  "Zur Übersicht": "To the overview",
  "Konzerte & Musik": "Concerts & music",
  "Party & Nachtleben": "Parties & nightlife",
  "Feste & Festivals": "Fêtes & festivals",
  "Märkte": "Markets",
  "Shows & Performances": "Shows & performances",
  "Comedy & Kabarett": "Comedy & cabaret",
  "Film & Kino": "Film & cinema",
  "Ausstellungen & Kunst": "Exhibitions & art",
  "Lesungen & Literatur": "Readings & literature",
  "Vorträge & Bildung": "Talks & learning",
  "Führungen & Touren": "Guided tours",
  "Sport & Bewegung": "Sports & activity",
  "Kinder & Familie": "Kids & family",
  "Essen & Trinken": "Food & drink",
  "Workshops & Kurse": "Workshops & courses",
  "Brauchtum & Tradition": "Customs & tradition",
  "Eintritt frei": "Free admission",
  "Festpreis": "Fixed price",
  "Ab-Preis": "Starting price",
  "Preisspanne": "Price range",
  "Spendenbasis": "Donation",
  "Keine Preisangabe": "No price given",
  "Stufenloser Zugang": "Step-free access",
  "Assistenzhunde willkommen": "Assistance dogs welcome",
  "Behindertenparkplatz": "Disabled parking",
  "Eigene Veranstaltung": "Own event",
  "Regionaler Tipp": "Regional tip",
  "Importiert": "Imported",
  "Wanderung": "Hike",
  "Spaziergang": "Walk",
  "Radtour": "Bike tour",
  "Laufstrecke": "Running route",
  "Klettertour": "Climbing route",
  "Winterwanderung": "Winter hike",
  "Schneeschuhtour": "Snowshoe tour",
  "Langlaufloipe": "Cross-country ski trail",
  "Kanutour": "Canoe tour",
  "Reittour": "Riding tour",
  "Sonstige Tour": "Other tour",
  "Strecke": "One-way"
}
